import { render, staticRenderFns } from "./StatusPackingPill.vue?vue&type=template&id=18b650aa&"
import script from "./StatusPackingPill.vue?vue&type=script&lang=js&"
export * from "./StatusPackingPill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports